import React from 'react';
import './Qsite.css';

export default function Headline({ text }) {
	return <div className='headline mb-3 d-flex justify-content-center'>{text}</div>;
}
